import { toast } from "react-toastify";
import { SliderAPI } from "../constants/apiRoutes";
import { sliderActions } from "../reducers/slider";
import apiService from "../utils/configAxios";
import { handleError } from "../utils/handleError";

export const createNewSlider = (data, navigate) => {
  return async (dispatch) => {
    dispatch(sliderActions.actionStart());
    try {
      await apiService.post(SliderAPI.create(), data);
      dispatch(sliderActions.actionSuccess());
    } catch (err) {
      dispatch(sliderActions.clearError());
      handleError(err);
    }
  };
};

export const updateSlider = (data, navigate, id) => {
  return (dispatch) => {
    dispatch(sliderActions.actionStart());
    return apiService
      .put(SliderAPI.update(id), data)
      .then((response) => {
        dispatch(sliderActions.actionSuccess());
        // toast.success("Uspešno ste izmenili kanal", {
        //   theme: "colored",
        // });
        // dispatch(sliderActions.clearError());
        // navigate("/slider-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const deleteSlider = (id) => {
  return (dispatch) => {
    return apiService
      .delete(SliderAPI.delete(id))
      .then((response) => {
        toast.success("Uspešno ste obrisali kanal", {
          theme: "colored",
        });

        dispatch(fetchSliderList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchSliderList = () => {
  return (dispatch) => {
    return apiService
      .get(SliderAPI.list())
      .then((response) => {
        dispatch(sliderActions.fetchSliderList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchSliderById = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(SliderAPI.getById(id))
      .then((response) => {
        dispatch(sliderActions.fetchSliderDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
